/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonHandleType } from './PersonHandleType';
import {
    PersonHandleTypeFromJSON,
    PersonHandleTypeFromJSONTyped,
    PersonHandleTypeToJSON,
    PersonHandleTypeToJSONTyped,
} from './PersonHandleType';

/**
 * 
 * @export
 * @interface PersonHandle
 */
export interface PersonHandle {
    /**
     * 
     * @type {PersonHandleType}
     * @memberof PersonHandle
     */
    type: PersonHandleType;
    /**
     * 
     * @type {string}
     * @memberof PersonHandle
     */
    value: string;
}



/**
 * Check if a given object implements the PersonHandle interface.
 */
export function instanceOfPersonHandle(value: object): value is PersonHandle {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PersonHandleFromJSON(json: any): PersonHandle {
    return PersonHandleFromJSONTyped(json, false);
}

export function PersonHandleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonHandle {
    if (json == null) {
        return json;
    }
    return {
        
        'type': PersonHandleTypeFromJSON(json['type']),
        'value': json['value'],
    };
}

export function PersonHandleToJSON(json: any): PersonHandle {
    return PersonHandleToJSONTyped(json, false);
}

export function PersonHandleToJSONTyped(value?: PersonHandle | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': PersonHandleTypeToJSON(value['type']),
        'value': value['value'],
    };
}

